export const volumeTypes = [
  '*',
  'configMap',
  'downwardAPI',
  'emptyDir',
  'flexVolume',
  'hostPath',
  'persistentVolumeClaim',
  'projected',
  'secret',
];

export const volumeTypeOptions = volumeTypes.map((t) => ({
  value: t,
  label: t,
}));

export const runAsUserTypeOptions = [
  { value: 'MustRunAs', label: 'MustRunAs' },
  { value: 'MustRunAsNonRoot', label: 'MustRunAsNonRoot' },
  { value: 'RunAsAny', label: 'RunAsAny' },
];

export const procMountTypeOptions = [
  { label: 'Default', value: 'Default' },
  { label: 'Unmasked', value: 'Unmasked' },
];

export const capabilityOptions = [
  'ALL',
  'AUDIT_CONTROL',
  'AUDIT_READ',
  'AUDIT_WRITE',
  'BLOCK_SUSPEND',
  'CHOWN',
  'DAC_OVERRIDE',
  'DAC_READ_SEARCH',
  'FOWNER',
  'FSETID',
  'IPC_LOCK',
  'IPC_OWNER',
  'KILL',
  'LEASE',
  'LINUX_IMMUTABLE',
  'MAC_ADMIN',
  'MAC_OVERRIDE',
  'MKNOD',
  'NET_ADMIN',
  'NET_BIND_SERVICE',
  'NET_BROADCAST',
  'NET_RAW',
  'SETFCAP',
  'SETGID',
  'SETPCAP',
  'SETUID',
  'SYS_ADMIN',
  'SYS_BOOT',
  'SYS_CHROOT',
  'SYS_MODULE',
  'SYS_NICE',
  'SYS_PACCT',
  'SYS_PTRACE',
  'SYS_RAWIO',
  'SYS_RESOURCE',
  'SYS_TIME',
  'SYS_TTY_CONFIG',
  'SYSLOG',
  'WAKE_ALARM',
].map((c) => ({ value: c, label: c }));
